import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import {
  Carousel,
  CarouselPill,
  CarouselPillSkeleton,
  useCarouselScroll,
} from '@/components';
import { LibraryUrlSearchParams, Routes } from '@/constants';
import { EVENT_CONSTANTS } from '@/services';
import { LibraryCategoryEntity, useFetchLibraryCategoriesQuery } from '@/store';

export const CategoriesCarousel = () => {
  const navigate = useNavigate();

  const {
    data: categories,
    isError,
    isLoading,
  } = useFetchLibraryCategoriesQuery();

  const createOnClickHandler = (category: LibraryCategoryEntity) => () => {
    const searchParams = new URLSearchParams();
    searchParams.set(LibraryUrlSearchParams.CATEGORY_SLUG, category.slug);
    navigate({
      pathname: Routes.LIBRARY,
      search: searchParams.toString(),
    });
  };

  const { scroll, containerId, isNearBeginning, isNearEnd } = useCarouselScroll(
    {
      itemWidth: 200,
      uKey: 'Popular Categories',
      referrer: {
        page: EVENT_CONSTANTS.PAGE.DISCOVER,
      },
    },
  );

  return (
    <>
      {!isError && (
        <Carousel
          title="Popular Categories"
          containerId={containerId}
          leftScrollIcon={!isNearBeginning}
          rightScrollIcon={!isNearEnd}
          scroll={scroll}
          navIconProps={{
            top: 'calc(50% + 12px)',
          }}>
          {isLoading
            ? Array.from({ length: 10 }).map((_, idx) => (
                <Box key={idx} mr={2}>
                  <CarouselPillSkeleton />
                </Box>
              ))
            : Object.values(categories?.entities || {}).map(c => (
                <CarouselPill
                  key={c.name}
                  label={c.name}
                  onClick={createOnClickHandler(c)}
                />
              ))}
        </Carousel>
      )}
    </>
  );
};
